export const headerHeight = 64
export const headerHeightDesktop = 88
export const miniBarHeight = 31
